import { render } from "./Divider.vue?vue&type=template&id=4304e0b6&scoped=true"
import script from "./Divider.vue?vue&type=script&lang=js"
export * from "./Divider.vue?vue&type=script&lang=js"

import "./Divider.vue?vue&type=style&index=0&id=4304e0b6&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4304e0b6"]])

export default __exports__